exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-card.selected-card {\r\n    width: 500px;\r\n    float: left;\r\n    margin: 10px;\r\n    position: relative;\r\n}\r\n\r\n.mat-form-field.extended-width {\r\n    margin-left: 5px;\r\n    margin-right: 5px;\r\n    width: 260px;\r\n}\r\n\r\n.mat-form-field.indented {\r\n    padding-left: 10px;\r\n}\r\n\r\n.mat-form-field.tiny {\r\n    width: 80px;\r\n}\r\n\r\n.mat-chip.spacing {\r\n    margin: 3px !important;\r\n    color: white;\r\n}\r\n\r\n.mat-card-title.title-size {\r\n    font-size: 16px;\r\n}\r\n\r\n.underwriters-select mat-form-field .mat-form-field-wrapper {\r\n    top: -19px;\r\n    border: solid 1px #c00;\r\n}\r\n\r\n.mat-process {\r\n    overflow-y: scroll;\r\n    max-height: 176px;\r\n    margin-top: -15px;\r\n}\r\n\r\n.searchbox {\r\n    padding-left: 16px;\r\n    width: 96%;\r\n}\r\n\r\n\r\n\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Uhm.Loops.Web/src/app/processor-closer-pipeline-reassignment/closer-reassignment/closer-reassignment.component.css
// module id = ../../../../../src/app/processor-closer-pipeline-reassignment/closer-reassignment/closer-reassignment.component.css
// module chunks = main